import React, { useState, useEffect } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function AutoUpdatePolicyForm({ policyData, agents }) {
  const [formData, setFormData] = useState({
    policyNumber: "",
    carrier: "",
    effectiveDate: "",
    clientFirstName: "",
    clientLastName: "",
    clientID: "",
    BI: "",
    PD: "",
    UM: "",
    UIM: "",
    TORT: "",
    premium: "",
    mainAgent: "",
    mainAgentSplit: "",
    refAgentOne: "",
    refAgentOneSplit: "",
    refAgentTwo: "",
    refAgentTwoSplit: "",
    refAgentThree: "",
    refAgentThreeSplit: "",
    refAgentFour: "",
    refAgentFourSplit: "",
    stateForms: "",
    UMStacked: "",
    UIMStacked: "",
    document: "",
    docName: ""
  });

  useEffect(() => {
    console.log("Auto Update Policy Form Component Launched with props:");
    console.log(policyData);
    setFormData((prev) => ({
      ...prev,
      policyNumber: policyData.policyNumber,
      carrier: policyData.carrier,
      effectiveDate: policyData.effectiveDate,
      clientFirstName: policyData.clientFirstName,
      clientLastName: policyData.clientLastName,
      clientID: policyData.clientID,
      BI: policyData.BI,
      PD: policyData.PD,
      UM: policyData.UM,
      UIM: policyData.UIM,
      TORT: policyData.TORT,
      premium: policyData.premium,
      mainAgent: policyData.mainAgent,
      mainAgentSplit: policyData.mainAgentSplit,
      refAgentOne: policyData.refAgentOne,
      refAgentOneSplit: policyData.refAgentOneSplit,
      refAgentTwo: policyData.refAgentTwo,
      refAgentTwoSplit: policyData.refAgentTwoSplit,
      refAgentThree: policyData.refAgentThree,
      refAgentThreeSplit: policyData.refAgentThreeSplit,
      refAgentFour: policyData.refAgentFour,
      refAgentFourSplit: policyData.refAgentFourSplit,
      stateForms: policyData.stateForms,
      UMStacked: policyData.UMStacked,
      UIMStacked: policyData.UIMStacked
    }));

    setTimeout(() => {
      console.log("Auto Update Policy Form State:");
      console.log(formData);
      if (formData.UMStacked === null || formData.UMStacked === "null") {
        alert("Uninsured Motorist Stacking election not selected");
      }
      if (formData.UIMStacked === null || formData.UIMStacked === "null") {
        alert("Underinsured Motorist Stacking election not selected");
      }
    }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePolicyUpdate = (event) => {
    event.preventDefault();
    console.log(formData);

    const autoInformation = {
      policyNumber: formData.policyNumber,
      carrier: formData.carrier,
      effectiveDate: formData.effectiveDate,
      clientFirstName: formData.clientFirstName,
      clientLastName: formData.clientLastName,
      clientID: formData.clientID,
      BI: formData.BI,
      PD: formData.PD,
      UM: formData.UM,
      UIM: formData.UIM,
      TORT: formData.TORT,
      premium: formData.premium,
      mainAgent: formData.mainAgent,
      mainAgentSplit: formData.mainAgentSplit,
      refAgentOne: formData.refAgentOne,
      refAgentOneSplit: formData.refAgentOneSplit,
      refAgentTwo: formData.refAgentTwo,
      refAgentTwoSplit: formData.refAgentTwoSplit,
      refAgentThree: formData.refAgentThree,
      refAgentThreeSplit: formData.refAgentThreeSplit,
      refAgentFour: formData.refAgentFour,
      refAgentFourSplit: formData.refAgentFourSplit,
      declaration: formData.declaration,
      stateForms: formData.stateForms
    };

    API.updateAutoPolicy(policyData._id, autoInformation)
      .then((res) => {
        console.log("Updated Vehicle Policy");
        console.log(res.data);
        if (formData.document.length > 0) {
          if (formData.docName.length > 0) {
            API.createDocumentForAuto(res.data._id, {
              docName: formData.docName,
              document: formData.document,
              policyid: res.data._id,
              type: "auto"
            })
              .then((_res) => {
                console.log(_res.data);
                cogoToast.success("Uploaded Auto Document!");
              })
              .catch((_err) => console.log(_err));
          } else {
            API.createDocumentForAuto(res.data._id, {
              docName: "Auto Document",
              document: formData.document,
              policyid: res.data._id,
              type: "auto"
            })
              .then((_res) => {
                console.log(_res.data);
                cogoToast.success("Uploaded Auto Document!");
              })
              .catch((_err) => console.log(_err));
          }
          cogoToast.success("Updated Vehicle Policy");
        }
      })
      .catch((_err) => console.log(_err));
  };

  return (
    <div>
      <div className="card">
        <h5 style={{ textAlign: "center" }}>Update a Vehicle Policy</h5>
        <div className="card-body">
          <form>
            <Table bordered hover>
              <tbody>
                <tr>
                  <td>Question</td>
                  <td>Input</td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Policy Number
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.policyNumber}
                      onChange={handleInputChange}
                      name="policyNumber"
                      placeholder="Policy Number"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Carrier
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.carrier}
                      onChange={handleInputChange}
                      name="carrier"
                      placeholder="Carrier"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Effective Date
                  </td>
                  <td>
                    <input
                      type="date"
                      value={formData.effectiveDate}
                      onChange={handleInputChange}
                      name="effectiveDate"
                      placeholder="effectiveDate"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Premium
                  </td>
                  <td>
                    <input
                      type="number"
                      value={formData.premium}
                      onChange={handleInputChange}
                      name="premium"
                      placeholder="Premium"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Client First Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.clientFirstName}
                      onChange={handleInputChange}
                      name="clientFirstName"
                      placeholder="Client First Name"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Client Last Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.clientLastName}
                      onChange={handleInputChange}
                      name="clientLastName"
                      placeholder="Client First Name"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Bodily Injury
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.BI}
                      onChange={handleInputChange}
                      name="BI"
                      placeholder="BI Limits"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Property Damage
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.PD}
                      onChange={handleInputChange}
                      name="PD"
                      placeholder="PD Limits"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Uninsured Motorist
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.UM}
                      onChange={handleInputChange}
                      name="UM"
                      placeholder="UM Limits"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Stacked UM?
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      disabled={true}
                      checked={formData.UMStacked}
                      onChange={handleInputChange}
                      name="UMStacked"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Underinsured Motorist
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.UIM}
                      onChange={handleInputChange}
                      name="UIM"
                      placeholder="UIM Limits"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Stacked UIM?
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      disabled={true}
                      checked={formData.UIMStacked}
                      onChange={handleInputChange}
                      name="UIMStacked"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Tort Option
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.TORT}
                      onChange={handleInputChange}
                      name="TORT"
                      placeholder="Tort Option"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    State Forms?
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={formData.stateForms}
                      onChange={handleInputChange}
                      name="stateForms"
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
            <Table>
              <tbody>
                <tr>
                  <th>Item Name</th>
                  <th>Agent</th>
                  <th>Split</th>
                </tr>

                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Main Agent
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.mainAgent}
                          onChange={handleInputChange}
                          name="mainAgent"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.mainAgent ? (
                      <input
                        type="number"
                        value={formData.mainAgentSplit}
                        name="mainAgentSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #1
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentOne}
                          onChange={handleInputChange}
                          name="refAgentOne"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentOne ? (
                      <input
                        type="number"
                        value={formData.refAgentOneSplit}
                        name="refAgentOneSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #2
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentTwo}
                          onChange={handleInputChange}
                          name="refAgentTwo"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentTwo ? (
                      <input
                        type="number"
                        value={formData.refAgentTwoSplit}
                        name="refAgentTwoSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #3
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentThree}
                          onChange={handleInputChange}
                          name="refAgentThree"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentThree ? (
                      <input
                        type="number"
                        value={formData.refAgentThreeSplit}
                        name="refAgentThreeSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #4
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentFour}
                          onChange={handleInputChange}
                          name="refAgentFour"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentFour ? (
                      <input
                        type="number"
                        value={formData.refAgentSplitFour}
                        name="refAgentSplitFour"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
              </tbody>
            </Table>
            <div style={{ textAlign: "center" }}>
              <button className="btn-success btn-sm btn" onClick={(e) => handlePolicyUpdate(e)}>
                Update Policy
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AutoUpdatePolicyForm;
